import styled from "styled-components"
import { useLocation, useNavigate } from "react-router-dom"
import AnimatedBorderButton from "components/AnimatedBorderButton"
import IconButton from "components/Buttons/IconButton"
import HomeIcon from "assets/icons/home.svg"
import MenuIcon from "assets/icons/apartment-finder-icon-new.svg"
import { useStore } from "store"

import routes from "../../routes"

export default function Navbar({ isNavbarVisible }) {
  const navigate = useNavigate()
  const location = useLocation()
  const setFinderVisible = useStore(state => state.setFinderVisible)
  const filterVisible = useStore(state => state.filterVisible)
  const setFilterVisible = useStore(state => state.setFilterVisible)

  const handleClick = v => {
    if (v === "/finder") {
      setFinderVisible(true)
      filterVisible && setFilterVisible(false)
    } else {
      setTimeout(() => navigate(v), 450)
    }
  }

  return (
    <>
      <NavContainer
        isNavbarVisible={location.pathname !== "/" || !isNavbarVisible}>
        <HomeButton
          icon={HomeIcon}
          onClick={() => {
            navigate("/")
          }}
        />
        {routes.map(item => {
          return item && item.isOnNavbar ? (
            <AnimatedBorderButton
              key={item.name}
              active={location.pathname === item.path}
              onClick={() => handleClick(item.path)}
              route={item.path}>
              {item.name}
            </AnimatedBorderButton>
          ) : null
        })}

        <FinderButton onClick={() => handleClick("/finder")}>
          <FinderButtonContent>
            <FinderIcon src={MenuIcon} alt="finder" />
            Find Your New Apartment
          </FinderButtonContent>
        </FinderButton>
      </NavContainer>
    </>
  )
}

const HomeButton = styled(IconButton)`
  position: absolute;
  left: 0.5em;
  bottom: 0.7em;
  pointer-events: all;
  width: 4.2vh;
  height: 4.2vh;
  padding: 0;
  -webkit-transition: all 0.2s ease-out;
  transition: all 0.2s ease-out;
`

const NavContainer = styled.div`
  pointer-events: none;
  position: fixed;
  bottom: 0;
  height: 7vh;
  z-index: 9;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  display: ${props => (props.isNavbarVisible ? "" : "none")};
`

const FinderButtonContent = styled.div`
  display: flex;
  align-items: center;

  font-family: GT-Sectra-Light;
  user-select: none;
`

const FinderIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 8px;
`

const FinderButton = styled.button`
  pointer-events: all;
  background: none;
  border: none;
  cursor: pointer;
  font-family: GT-Sectra-Light;
  font-size: 1.2rem;
  color: inherit;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease-out;
  user-select: none;

  &:hover {
    opacity: 0.6;
  }
`
